<div class="relative min-h-screen" [inert]="confirmation.current() !== null">
  <div [class.presentation-mobile-content]="showBottomNav">
    <router-outlet></router-outlet>
  </div>
  @if (showBottomNav) {
    <app-bottom-navbar></app-bottom-navbar>
  }
</div>

<app-ui-confirmation-dialog></app-ui-confirmation-dialog>
